import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, thunderbolt"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H21.25C21.6642 4 22 4.33579 22 4.75V17.25C22 17.6642 21.6642 18 21.25 18H16V20.25C16 20.6642 15.6642 21 15.25 21H8.75C8.33579 21 8 20.6642 8 20.25V18H2.75C2.33579 18 2 17.6642 2 17.25V4.75ZM9.5 18V19.5H14.5V18H9.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStudioDisplay;
